import React, { useState, useEffect } from 'react';
import { getBigFiveQuestions, submitBigFiveTest } from '../services/bigFiveTestService';
import { useNavigate } from 'react-router-dom';
import icon from '../assets/test.svg';

import axios from 'axios';

const BigFiveTestPage: React.FC = () => {
  const [questions, setQuestions] = useState<any[]>([]);
  const [answers, setAnswers] = useState<{ [key: string]: number }>({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const { data } = await axios.get('/api/big-five-test/questions');
        setQuestions(data);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching questions:', error);
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  const handleAnswerChange = (questionId: string, score: number) => {
    setAnswers(prevAnswers => ({
      ...prevAnswers,
      [questionId]: score,
    }));
  };

  const handleSubmit = async () => {
    if (Object.keys(answers).length !== questions.length) {
      alert('모든 질문에 답해주세요.');
      return;
    }

    try {
      const { data } = await axios.post('/api/big-five-test/submit', { answers });
      const results = data?.results ?? data;

      navigate('/big-five-test-result', { state: { results } });
    } catch (error) {
      console.error('Error submitting test:', error);
    }
  };
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="main-container">
      <div className="big-five-test-page">
        <div className="page-header">
          <img src={icon} alt="Mind Thermometer Icon" className="page-header__icon" />
          <h2 className="page-header__title">Big-Five 성격검사</h2>
          <p className="page-header__subtitle">검사를 통해 나의 성격 유형을 알아보세요.</p>
        </div>
        {questions.map(q => (
          <div key={q.id} className="question-card">
            <p>{q.text}</p>
            <div className="answers">
              <label>
                <input
                  type="radio"
                  name={q.id}
                  value={1}
                  onChange={() => handleAnswerChange(q.id, 1)}
                  checked={answers[q.id] === 1}
                />
                <span>매우 비동의</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={q.id}
                  value={2}
                  onChange={() => handleAnswerChange(q.id, 2)}
                  checked={answers[q.id] === 2}
                />
                <span>비동의</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={q.id}
                  value={3}
                  onChange={() => handleAnswerChange(q.id, 3)}
                  checked={answers[q.id] === 3}
                />
                <span>보통</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={q.id}
                  value={4}
                  onChange={() => handleAnswerChange(q.id, 4)}
                  checked={answers[q.id] === 4}
                />
                <span>동의</span>
              </label>
              <label>
                <input
                  type="radio"
                  name={q.id}
                  value={5}
                  onChange={() => handleAnswerChange(q.id, 5)}
                  checked={answers[q.id] === 5}
                />
                <span>매우 동의</span>
              </label>
            </div>
          </div>
        ))}
        <button onClick={handleSubmit} className="submit-button">
          결과 보기
        </button>
      </div>
    </div>
  );
};

export default BigFiveTestPage;
